import { Map, Record } from "immutable";
import { RootState, RootActions } from "common/reducers";
import { receive, receiveDraft, reset } from "common/reducers/Utils";
import { doorFromJSON, DoorRecord } from "common/records/Door";
import { RECEIVE_DOOR, RECEIVE_DRAFT_DOOR, RESET_DOOR } from "common/reducers/door.actions";

export const DoorStateRecord = Record({
  byId: Map<number, DoorRecord>(),
  lastSavedById: Map<number, DoorRecord>(),
});

export const initialState = DoorStateRecord();
export type DoorState = typeof initialState;

const model = "doors";

export const doorReducer = (state: RootState, action: RootActions): RootState => {
  if (state && !state.getIn([model])) {
    state = state.setIn([model], initialState);
  }
  switch (action.type) {
    case RECEIVE_DOOR:
      return receive(state, model, doorFromJSON(action.payload.door));

    case RECEIVE_DRAFT_DOOR:
      return receiveDraft(state, model, action.payload.door, doorFromJSON);

    case RESET_DOOR:
      return reset(state, model, action.payload.doorId);

    default:
      return state;
  }
};
